// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 3: JESUS CHRISTUS
// ============================================================================
// Levels 27-39 (13 Ebenen, 39 Fragen)

export const chapter3Translations = {
  name: 'Jesus Christus',
  description: 'Das Wort ward Fleisch... Christus zu kennen ist ewiges Leben',
  
  spiritualWisdom: {
    principle: 'Jesus Christus zu kennen ist ewiges Leben',
    scripture: 'Das ist aber das ewige Leben, dass sie dich, den allein wahren Gott, und den du gesandt hast, Jesus Christus, erkennen (Johannes 17:3)',
    application: 'Jeder Aspekt des Lebens Jesu offenbart Gott und nährt unsere Seele für die Ewigkeit'
  },
  
  levels: {
    27: {
      name: 'Die Verkündigung',
      challenge: 'Der Engel Gabriel wurde von Gott gesandt in eine Stadt in Galiläa...',
      easy: {
        question: 'Welcher Engel verkündete Maria, dass sie Jesus gebären würde?',
        options: ['Michael', 'Gabriel', 'Raphael', 'Uriel'],
        hint: 'Der Bote Gottes',
        funFact: '👼 Gabriel bedeutet Kraft Gottes - der Engel der großen Ankündigungen!'
      },
      medium: {
        question: 'Was war Marias erste Reaktion auf diese Ankündigung?',
        options: [
          'Sofortige Freude',
          'Völliger Unglaube',
          'Verwirrung und die Frage Wie soll das geschehen?',
          'Angst'
        ],
        hint: 'Eine praktische und berechtigte Frage',
        funFact: '🤔 Maria stellt eine logische Frage, behält aber ein offenes Herz für Gott!'
      },
      hard: {
        question: 'Was lehrt uns Marias Unterwerfung unter den göttlichen Willen?',
        options: [
          'Passivität vor Prüfungen',
          'Glaube, der vertraut, auch ohne alles zu verstehen',
          'Blinder Gehorsam',
          'Resignation'
        ],
        hint: 'Es geht darum, Gott auch im Unbekannten zu vertrauen',
        funFact: '🙏 Mir geschehe nach deinem Wort - Vorbild vertrauensvollen Glaubens!'
      }
    },
    
    28: {
      name: 'Die Geburt',
      challenge: 'Sie gebar ihren ersten Sohn, wickelte ihn in Windeln und legte ihn in eine Krippe...',
      easy: {
        question: 'In welcher Stadt wurde Jesus geboren?',
        options: ['Nazareth', 'Jerusalem', 'Bethlehem', 'Kapernaum'],
        hint: 'Die Stadt Davids',
        funFact: '🏘️ Bethlehem bedeutet Haus des Brotes - Jesus, Brot des Lebens!'
      },
      medium: {
        question: 'Wer erhielt als Erstes die Nachricht von der Geburt?',
        options: [
          'Die Weisen',
          'Die Hirten auf dem Feld',
          'Die Priester des Tempels',
          'Marias Familie'
        ],
        hint: 'Einfache Leute, die ihre Herden hüteten',
        funFact: '🐑 Gott verkündet zuerst den demütigen Hirten - das Evangelium für alle!'
      },
      hard: {
        question: 'Was symbolisiert Jesus in einer Krippe geboren?',
        options: [
          'Die Armut seiner Eltern',
          'Die Demut Gottes, der sich zu uns herabneigt',
          'Der Platzmangel',
          'Ländliche Einfachheit'
        ],
        hint: 'Es geht um die göttliche Menschwerdung in Demut',
        funFact: '👶 Der Schöpfer des Universums wird in einem Stall geboren - unendliche Liebe!'
      }
    },

    29: {
      name: 'Die Weisen aus dem Morgenland',
      challenge: 'Weise aus dem Morgenland kamen nach Jerusalem und fragten...',
      easy: {
        question: 'Was führte die Weisen zu Jesus?',
        options: ['Ein Engel', 'Ein Stern', 'Eine Vision', 'Eine Karte'],
        hint: 'Ein Gestirn am Himmel',
        funFact: '⭐ Der Stern zeigt, dass Jesus das Licht der Völker ist!'
      },
      medium: {
        question: 'Welche Gaben brachten die Weisen?',
        options: [
          'Nahrung',
          'Gold, Weihrauch und Myrrhe',
          'Kostbare Kleider',
          'Spielzeug'
        ],
        hint: 'Drei symbolische und kostbare Geschenke',
        funFact: '🎁 Gold (Königtum), Weihrauch (Göttlichkeit), Myrrhe (Opfer) - Jesu ganze Mission!'
      },
      hard: {
        question: 'Was repräsentieren diese heidnischen Weisen in Gottes Plan?',
        options: [
          'Die Überlegenheit anderer Religionen',
          'Die Universalität des Heils für alle Völker',
          'Materieller Reichtum',
          'Antike Wissenschaft'
        ],
        hint: 'Es geht um die Öffnung des Heils für alle Nationen',
        funFact: '🌍 Die Weisen deuten das Evangelium an, das die ganze Welt erreichen wird!'
      }
    },

    30: {
      name: 'Die Taufe Jesu',
      challenge: 'Als Jesus getauft war, stieg er sogleich aus dem Wasser...',
      easy: {
        question: 'Wer taufte Jesus?',
        options: ['Petrus', 'Johannes der Täufer', 'Andreas', 'Jakobus'],
        hint: 'Der Vorläufer Jesu',
        funFact: '🌊 Johannes der Täufer hielt sich für unwürdig, die Sandalen Jesu zu lösen!'
      },
      medium: {
        question: 'Was kam bei seiner Taufe auf Jesus herab?',
        options: [
          'Ein Licht',
          'Eine Taube (der Heilige Geist)',
          'Ein Engel',
          'Nur eine Stimme'
        ],
        hint: 'Der Vogel, Symbol des Friedens',
        funFact: '🕊️ Die Taube offenbart die göttliche Salbung zum Beginn des Dienstes!'
      },
      hard: {
        question: 'Warum ließ sich der sündlose Jesus taufen?',
        options: [
          'Um ein Beispiel zu geben',
          'Um alle Gerechtigkeit zu erfüllen und sich mit uns zu identifizieren',
          'Wegen religiöser Verpflichtung',
          'Um Vergebung zu empfangen'
        ],
        hint: 'Es geht um Solidarität mit der sündigen Menschheit',
        funFact: '❤️ Jesus identifiziert sich völlig mit uns, um uns besser zu retten!'
      }
    },

    31: {
      name: 'Die Versuchung in der Wüste',
      challenge: 'Jesus wurde vom Geist in die Wüste geführt, um vom Teufel versucht zu werden...',
      easy: {
        question: 'Wie lange fastete Jesus in der Wüste?',
        options: ['30 Tage', '40 Tage', '50 Tage', '60 Tage'],
        hint: 'Die biblische Zahl der Prüfung',
        funFact: '🏜️ Wie Mose und Elia, 40 Tage intensive geistliche Vorbereitung!'
      },
      medium: {
        question: 'Wie wies Jesus jede Versuchung zurück?',
        options: [
          'Durch eigene Kraft',
          'Durch Zitieren der Schrift',
          'Durch Ignorieren Satans',
          'Nur durch Gebet'
        ],
        hint: 'Die geistliche Waffe par excellence',
        funFact: '📖 Es steht geschrieben... - Gottes Wort, Schwert des Geistes!'
      },
      hard: {
        question: 'Was lehrt uns die Versuchung Jesu über unsere Kämpfe?',
        options: [
          'Versuchungen sind Sünde',
          'Versuchung kann durch Wort und Glauben überwunden werden',
          'Man muss jede Wüste fliehen',
          'Nur Jesus kann widerstehen'
        ],
        hint: 'Es geht um unsere Strategie gegen Versuchungen',
        funFact: '⚔️ Jesus zeigt uns, wie wir siegen: Gottes Wort + aktiver Glaube!'
      }
    },

    32: {
      name: 'Die Ersten Jünger',
      challenge: 'Jesus sprach zu ihnen: Folgt mir nach, und ich will euch zu Menschenfischern machen...',
      easy: {
        question: 'Was war der Beruf von Petrus und Andreas?',
        options: ['Hirten', 'Fischer', 'Zimmermänner', 'Zöllner'],
        hint: 'Ein Beruf am See Genezareth',
        funFact: '🎣 Jesus verwandelt Fischer in Menschenfischer!'
      },
      medium: {
        question: 'Wie reagierten die ersten Jünger auf den Ruf?',
        options: [
          'Sie zögerten lange',
          'Sie forderten Beweise',
          'Sie ließen alles zurück und folgten ihm sofort',
          'Sie verhandelten'
        ],
        hint: 'Eine sofortige und vollständige Antwort',
        funFact: '🚶 Jesu Autorität war so offensichtlich, dass sie sofort gehorchten!'
      },
      hard: {
        question: 'Was bedeutet Jesus nachfolgen in unserer Zeit?',
        options: [
          'Die Arbeit aufgeben',
          'Nach seinen Lehren und seinem Willen leben',
          'Einer isolierten Gemeinschaft beitreten',
          'Nur missionieren'
        ],
        hint: 'Es geht um eine Lebens- und Prioritätenverwandlung',
        funFact: '✨ Jesus nachfolgen verwandelt unsere Herzen, Entscheidungen, Bestimmung!'
      }
    },

    33: {
      name: 'Die Bergpredigt',
      challenge: 'Selig sind die geistlich Armen, denn ihrer ist das Himmelreich...',
      easy: {
        question: 'Was ist die erste Seligpreisung in der Bergpredigt?',
        options: [
          'Selig sind die reinen Herzens',
          'Selig sind die geistlich Armen',
          'Selig sind die Sanftmütigen',
          'Selig sind die Friedfertigen'
        ],
        hint: 'Sie betrifft geistliche Demut',
        funFact: '😊 Die geistlich Armen kennen ihr Bedürfnis nach Gott - Tor zum Reich!'
      },
      medium: {
        question: 'Was sagte Jesus über die Friedfertigen?',
        options: [
          'Sie werden glücklich sein',
          'Sie werden Gottes Kinder heißen',
          'Sie werden geliebt sein',
          'Sie werden stark sein'
        ],
        hint: 'Eine besondere göttliche Identität',
        funFact: '👑 Friedensstifter ähneln Gott - lebendiges Zeugnis seiner Natur!'
      },
      hard: {
        question: 'Wie kehren die Seligpreisungen die Werte der Welt um?',
        options: [
          'Durch Verurteilung des Reichtums',
          'Durch Isolation der Gläubigen',
          'Durch Verkündigung des Segens derer, die die Welt verachtet',
          'Durch Abschaffung der Gesetze'
        ],
        hint: 'Es geht um göttliche Werte im Gegensatz zu weltlichen',
        funFact: '🔄 Die Seligpreisungen verwandeln unsere Sicht auf Glück und Erfolg!'
      }
    },

    34: {
      name: 'Die Gleichnisse vom Reich',
      challenge: 'Er lehrte sie vieles in Gleichnissen...',
      easy: {
        question: 'Im Gleichnis vom Sämann, was stellt der Same dar?',
        options: [
          'Geld',
          'Das Wort Gottes',
          'Gute Werke',
          'Liebe'
        ],
        hint: 'Was Jesus verkündet und lehrt',
        funFact: '🌱 Das Wort Gottes keimt und wächst in unseren Herzen!'
      },
      medium: {
        question: 'Im Gleichnis vom Senfkorn, was symbolisiert dieser kleine Same?',
        options: [
          'Menschliche Schwäche',
          'Das Reich, das klein beginnt, aber groß wird',
          'Die Bedeutung von Details',
          'Die Natur'
        ],
        hint: 'Etwas, das spektakulär wächst',
        funFact: '🌳 Aus dem kleinsten Samen wird ein großer Baum - Macht des Reiches!'
      },
      hard: {
        question: 'Warum lehrte Jesus in Gleichnissen?',
        options: [
          'Um seine Botschaft zu komplizieren',
          'Um geistliche Wahrheiten durch vertraute Bilder zu enthüllen',
          'Aus Zeitmangel',
          'Um Intelligenz zu testen'
        ],
        hint: 'Es geht darum, die Geheimnisse des Reiches zugänglich zu machen',
        funFact: '💡 Gleichnisse enthüllen den offenen Herzen und verhüllen den verschlossenen!'
      }
    },

    35: {
      name: 'Die Wunder Jesu',
      challenge: 'Er stillte den Wind und sprach zum Meer: Schweig! Verstumme!...',
      easy: {
        question: 'Mit wie vielen Broten speiste Jesus 5000 Männer?',
        options: ['3 Brote', '5 Brote', '7 Brote', '12 Brote'],
        hint: 'Die gleiche Anzahl wie die Fische',
        funFact: '🍞 5 Brote und 2 Fische werden zum Festmahl - göttliche Großzügigkeit!'
      },
      medium: {
        question: 'Was sagten die Jünger, als Jesus den Sturm stillte?',
        options: [
          'Er ist ein Zauberer',
          'Wer ist dieser, dem Wind und Meer gehorchen?',
          'Das ist normal',
          'Wir müssen hier weg'
        ],
        hint: 'Eine Frage über Jesu Identität',
        funFact: '⛈️ Selbst die Elemente erkennen ihren Schöpfer und Meister!'
      },
      hard: {
        question: 'Was ist der Hauptzweck der Wunder Jesu?',
        options: [
          'Die Massen beeindrucken',
          'Seine Göttlichkeit offenbaren und Gottes Liebe zeigen',
          'Einfluss gewinnen',
          'Nur materiell helfen'
        ],
        hint: 'Es geht um göttliche Offenbarung und Mitgefühl',
        funFact: '❤️ Jedes Wunder offenbart Gottes Herz: Liebe, Mitgefühl, Macht!'
      }
    },

    36: {
      name: 'Die Verklärung',
      challenge: 'Er wurde vor ihnen verklärt; sein Angesicht leuchtete wie die Sonne...',
      easy: {
        question: 'Welche Jünger sahen Jesus verklärt?',
        options: [
          'Alle zwölf',
          'Petrus, Jakobus und Johannes',
          'Nur Petrus und Johannes',
          'Die Frauen, die ihm folgten'
        ],
        hint: 'Der innere Kreis der drei',
        funFact: '⛰️ Petrus, Jakobus und Johannes: privilegierte Zeugen der göttlichen Herrlichkeit!'
      },
      medium: {
        question: 'Welche Persönlichkeiten des Alten Testaments erschienen?',
        options: [
          'Abraham und Isaak',
          'David und Salomo',
          'Mose und Elia',
          'Adam und Noah'
        ],
        hint: 'Der Vertreter des Gesetzes und der Propheten',
        funFact: '📜 Mose (Gesetz) und Elia (Propheten) bezeugen Jesus!'
      },
      hard: {
        question: 'Was offenbart diese Verklärung über Jesu Natur?',
        options: [
          'Er ist ein großer Prophet',
          'Seine verborgene Göttlichkeit manifestiert sich vorübergehend',
          'Er beherrscht das Licht',
          'Er kann sein Aussehen ändern'
        ],
        hint: 'Es geht um die Offenbarung seiner göttlichen Natur',
        funFact: '✨ Jesu göttliche Herrlichkeit strahlt durch - Vorgeschmack auf seine Auferstehung!'
      }
    },

    37: {
      name: 'Der Triumphale Einzug',
      challenge: 'Hosanna dem Sohn Davids! Gelobt sei, der da kommt im Namen des Herrn!...',
      easy: {
        question: 'Auf welchem Tier ritt Jesus in Jerusalem ein?',
        options: ['Einem Pferd', 'Einem Esel', 'Einem Kamel', 'Zu Fuß'],
        hint: 'Ein Tier, Symbol der Demut und des Friedens',
        funFact: '🐴 Der Esel symbolisiert den demütigen König, der in Frieden kommt, nicht im Krieg!'
      },
      medium: {
        question: 'Was rief die Menge, als sie Jesus zujubelte?',
        options: [
          'Es lebe der König!',
          'Hosanna! Gelobt sei, der da kommt im Namen des Herrn!',
          'Ehre sei Gott!',
          'Freiheit!'
        ],
        hint: 'Ein Ruf der Freude und des Segens',
        funFact: '🌿 "Hosanna" bedeutet "Rette jetzt" - Ruf nach göttlichem Heil!'
      },
      hard: {
        question: 'Warum ist dieser Einzug "triumphal" aber tragisch?',
        options: [
          'Es waren wenige Menschen da',
          'Die Menge, die ihn bejubelt, wird ihn in 5 Tagen ablehnen',
          'Die Behörden waren abwesend',
          'Es regnete'
        ],
        hint: 'Es geht um die Unbeständigkeit des menschlichen Herzens',
        funFact: '💔 Dieselbe Menge wird einige Tage später "Kreuzige ihn!" schreien!'
      }
    },

    38: {
      name: 'Das Letzte Abendmahl',
      challenge: 'Nehmt und esst, das ist mein Leib, der für euch gegeben wird...',
      easy: {
        question: 'Was tat Jesus mit den Füßen seiner Jünger?',
        options: [
          'Er segnete sie',
          'Er wusch sie',
          'Er salbte sie',
          'Er küsste sie'
        ],
        hint: 'Eine Geste der Demut und des Dienstes',
        funFact: '🦶 Der Meister wird zum Diener - Revolution der Liebe und Demut!'
      },
      medium: {
        question: 'Was setzte Jesus bei diesem Mahl ein?',
        options: [
          'Die Taufe',
          'Das Abendmahl (Kommunion)',
          'Das Vaterunser',
          'Das Fasten'
        ],
        hint: 'Ein Sakrament mit Brot und Wein',
        funFact: '🍞🍷 Brot und Wein werden ewige Symbole für Opfer und Liebe!'
      },
      hard: {
        question: 'Was bedeutet "Dies tut zu meinem Gedächtnis"?',
        options: [
          'Wiederholt dieses Mahl',
          'Feiert meinen Tod und meine Auferstehung bis zu meiner Rückkehr',
          'Erinnert euch an meine Worte',
          'Liebt einander'
        ],
        hint: 'Es geht um ein lebendiges und prophetisches Gedenken',
        funFact: '⏳ Jedes Abendmahl verkündet den Tod des Herrn bis zu seiner Rückkehr!'
      }
    },

    39: {
      name: 'Gethsemane',
      challenge: 'Mein Vater, ist es möglich, so gehe dieser Kelch an mir vorüber...',
      easy: {
        question: 'Wo betete Jesus vor seiner Verhaftung?',
        options: [
          'Im Tempel',
          'Im Garten Gethsemane',
          'Auf dem Ölberg',
          'Bei Freunden'
        ],
        hint: 'Ein Garten mit Olivenbäumen',
        funFact: '🫒 Gethsemane bedeutet "Ölpresse" - Ort intensiven Drucks!'
      },
      medium: {
        question: 'Was taten die Jünger, während Jesus betete?',
        options: [
          'Sie beteten mit ihm',
          'Sie schliefen ein',
          'Sie hielten Wache',
          'Sie gingen weg'
        ],
        hint: 'Sie konnten nicht eine Stunde wachen',
        funFact: '😴 Der Geist ist willig, aber das Fleisch ist schwach - menschliche Schwäche!'
      },
      hard: {
        question: 'Was offenbart Jesu Todeskampf über seine Natur?',
        options: [
          'Er war nur Mensch',
          'Er war vollkommen Mensch UND vollkommen Gott',
          'Er zweifelte an seiner Mission',
          'Er war schwach'
        ],
        hint: 'Es geht um das Geheimnis der Menschwerdung',
        funFact: '✝️ Jesus übernimmt die menschliche Angst vollständig und bleibt Gott treu!'
      }
    }
  }
};

export default chapter3Translations;
